module.exports = __webpack_public_path__ + "static/media/info-circleBlack.9f1b8fae.svg";